var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Steps',{attrs:{"current":_vm.currentItemIndex,"size":_vm.size}},_vm._l((_vm.items),function(item,index){return _c('Step',{key:index,class:{
            active: _vm.currentItemIndex >= index,
        },attrs:{"title":_vm.$t(item),"icon":_vm.getIcon(item)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }